import styled from 'styled-components';

export const SWrapper = styled.div.attrs({ role: 'group' })<{
  variant: 'horizontal' | 'vertical';
}>`
  display: flex;
  flex-direction: ${({ variant }) => (variant === 'horizontal' ? 'row' : 'column')};
`;
